import React from "react";
import {
  LIVE_PROOF_CHAT_HEADER,
  LIVE_PROOF_CHAT_HISTORY,
  LIVE_PROOF_LATENCY_BADGE_LIMIT,
  LIVE_PROOF_TIMELINE,
  LIVE_PROOF_TIMELINE_DURATION,
} from "./liveProofContent.js";

const LiveProofChat = () => {
  let assistantCount = 0;

  return (
    <div className="cursor-live-proof-phone" data-testid="live-proof-chat">
      <div className="cursor-live-proof-phone-shell">
        <div className="cursor-live-proof-phone-header">
          <div className="cursor-live-proof-phone-header-left">
            <span className="cursor-live-proof-live-dot" aria-hidden="true">
              <span className="cursor-live-proof-live-ping" />
              <span className="cursor-live-proof-live-core" />
            </span>
            <span className="cursor-live-proof-phone-label">{LIVE_PROOF_CHAT_HEADER.label}</span>
          </div>
          <span className="cursor-live-proof-booked-pill">
            ✓ {LIVE_PROOF_CHAT_HEADER.status}
          </span>
        </div>

        <div className="cursor-live-proof-timeline" data-testid="live-proof-timeline">
          <div className="cursor-live-proof-timeline-track">
            <div className="cursor-live-proof-timeline-rail" aria-hidden="true" />
            {LIVE_PROOF_TIMELINE.map((step) => (
              <div key={step.label} className="cursor-live-proof-timeline-step">
                <span className="cursor-live-proof-timeline-dot" aria-hidden="true" />
                <span className="cursor-live-proof-timeline-time">{step.time}</span>
                <span className="cursor-live-proof-timeline-label">{step.label}</span>
              </div>
            ))}
          </div>
          <p className="cursor-live-proof-timeline-duration">{LIVE_PROOF_TIMELINE_DURATION}</p>
        </div>

        <div className="cursor-live-proof-phone-thread">
          {LIVE_PROOF_CHAT_HISTORY.map((message, index) => {
            const isUser = message.role === "user";
            const messageKey = message.message_id ?? message.timestamp ?? index;

            let bubbleClass = "cursor-live-proof-bubble-assistant";
            if (isUser) {
              bubbleClass = "cursor-live-proof-bubble-user";
            } else if (message.highlight) {
              bubbleClass = "cursor-live-proof-bubble-booked";
            }

            let showLatency = false;
            if (!isUser) {
              assistantCount += 1;
              showLatency =
                message.response_time_seconds != null &&
                assistantCount <= LIVE_PROOF_LATENCY_BADGE_LIMIT;
            }

            return (
              <div
                key={messageKey}
                className={`cursor-live-proof-row${isUser ? " cursor-live-proof-row-user" : ""}`}
              >
                <div className={`cursor-live-proof-bubble ${bubbleClass}`}>{message.content}</div>
                {showLatency && (
                  <span
                    className="cursor-live-proof-latency"
                    data-testid={`live-proof-latency-${index}`}
                  >
                    ⚡ Replied in {message.response_time_seconds}s
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LiveProofChat;
